module.exports = "pegasus_template/assets/blocks/landing-page-layout-11.png";